import { css } from 'aphrodite';
import { styleSheet } from './styles';

type Props = {
	description: string;
	image?: string;
};

export const DonationSurveyHeader = ({ description, image }: Props) => {
	return (
		<div className={css(styleSheet.container, image && styleSheet.containerWithImage)}>
			{image && (
				<div className={css(styleSheet.imageContainer)}>
					<img className={css(styleSheet.image)} src={image} alt='Donation Survey Image' />
				</div>
			)}

			<div className={css(styleSheet.contentContainer, image && styleSheet.contentContainerWithImage)}>
				<p className={css(styleSheet.description)}>{description}</p>
			</div>
		</div>
	);
};
